import { useState } from 'react'

import Section from '../Section'

import play from '../../images/botao-play.png'
import zoom from '../../images/mais-zoom.png'
import closeIcon from '../../images/close.png'

import * as S from './styles'

type Props = {
    defaultCover: string
    name: string
    items: GalleryItem[]
}

interface ModalState extends GalleryItem {
    isVisible: boolean
}

const Gallery = ({ defaultCover, name, items }: Props) => {
    const [modal, setModal] = useState<ModalState>({
        isVisible: false,
        type: 'image',
        url: ''
    })

    const getMediaCover = (item: GalleryItem) => {
        if (item.type === 'image') return item.url
        return defaultCover
    }

    const getMediaIcon = (item: GalleryItem) => {
        if (item.type === 'image') return zoom
        return play
    }

    const closeModal = () => {
        setModal({
            isVisible: false,
            type: 'image',
            url: ''
        })
    }

    return (
        <>
            <Section title="Galeria" background="black">
                <S.Items>
                    {items.map((media, index) => (
                        <S.Item
                            key={media.url}
                            onClick={() => {
                                setModal({
                                    isVisible: true,
                                    type: media.type,
                                    url: media.url
                                })
                            }}
                        >
                            <img
                                src={getMediaCover(media)}
                                alt={`Media ${index + 1} de ${name}`}
                            />
                            <S.Action>
                                <img
                                    src={getMediaIcon(media)}
                                    alt="Clique para maximixar a mídia"
                                />
                            </S.Action>
                        </S.Item>
                    ))}
                </S.Items>
            </Section>
            <S.Modal className={modal.isVisible ? 'is-visible' : ''}>
                <S.ModalContent className="container">
                    <header>
                        <h4>{name}</h4>
                        <img
                            src={closeIcon}
                            alt="icode de fechar"
                            onClick={closeModal}
                        />
                    </header>
                    {modal.type === 'image' ? (
                        <img src={modal.url} />
                    ) : (
                        <iframe frameBorder={0} src={modal.url} />
                    )}
                </S.ModalContent>
                <div
                    onClick={() => {
                        closeModal()
                    }}
                    className="overlay"
                ></div>
            </S.Modal>
        </>
    )
}

export default Gallery
